<template>
  <section
    id="home"
    style="
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
  <div style="width: 2px; height: 2px; background-color: red;" @click="goPage('myMeeting')"></div>
    <!-- <button
      v-if="isSuperAdmin"
      style="
        background-color: blueviolet;
        color: white;
        border-radius: 10px;
        padding: 10px 10px;
        width: 100px;
        height: 80px;
      "
      @click="goPage('myMeeting')"
    >
      임시 로그인
    </button>
    <button
      style="
        background-color: firebrick;
        color: white;
        border-radius: 10px;
        padding: 10px 10px;
        width: 100px;
        height: 80px;
      "
      @click="goPage('ssoLogin')"
    >
      sso 로그인
    </button> -->
    <!-- <div class="wrap">
      <div class="top_bg_wrap">
        <div class="main_wrap">
          <div class="main_content">
            <div class="c_link">
              <div class="c_link_bt_st" style="padding-top: 90px;">
                KRX 시스템 사용자
                <p>
                  <button class="bt_st" @click="goPage('myMeeting')">
                    로그인
                  </button>
                </p>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </div>

    </div> -->
    <div class="hplo" @click="goPage('myMeeting')"></div>
    <citizen-participation-dialog
      :dialog="citizenParticipationDialog.dialog"
      :closeDialog="closeCitizenParticipationDialog"
    />
    <login-test-dialog
      :dialog="loginTestDialog.dialog"
      :closeDialog="closeLoginTestDialog"
    />
  </section>
</template>

<script>
import menu from '@/api/menu';
import 'swiper/css/swiper.css';
import { mapState } from 'vuex';
import CitizenParticipationDialog from '@/components/popup/CitizenParticipationDialog';
import LoginTestDialog from '@/components/popup/LoginTestDialog.vue';
import SlideUpDown from 'vue-slide-up-down';
import Util from '@/util';

export default {
  name: 'SectionHome',
  components: {
    CitizenParticipationDialog,
    LoginTestDialog,
    SlideUpDown,
  },
  data: () => ({
    isSuperAdmin: false,
    active: false,
    show: true,
    contentLength: 2,
    showOptions: false,
    useHidden: true,
    timing: '',
    duration: 500,
    citizenParticipationDialog: {
      dialog: false,
    },
    loginTestDialog: {
      dialog: false,
    },
  }),
  computed: {
    ...mapState(['isUserLoggedIn']),
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh';
      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
  async created () {
    this.$http
      .get('/api/auth/isSuperAdmin')
      .then((response) => {
        if (response) {
          this.isSuperAdmin = true;
        }
      }).catch(error => {
        if (error) {
          console.log(error);
        }
      });
    if (this.$store.state && this.$store.state.token) {
      let result = await Util.hasSession(this);
      if (result) {
        const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
          .data;
        if (isAdmin === true) {
          this.$router.push('/dashboard');
        } else {
          this.$router.push('/sMeeting');
        }
      }
    }
  },
  async activated () {
    console.log(`Home this.$store.state`, this.$store.state);
    if (this.$store.state && this.$store.state.token) {
      let result = await Util.hasSession(this);
      if (result) {
        const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
          .data;
        if (isAdmin === true) {
          this.$router.push('/dashboard');
        } else {
          this.$router.push('/sMeeting');
        }
      }
    }
  },
  methods: {
    langMouseEnter() {
      this.active = true;
    },
    langMouseLeave() {
      this.active = false;
    },
    overIcon(imgPath, type) {
      let src_off = imgPath;
      let src = src_off.replace('_off', '_on');

      if (type === 'connection') {
        this.connectionStateImg = src;
      } else {
        this.userGuideImg = src;
      }
    },
    logout() {
      window.getApp.$emit('APP_LOGOUT');
    },
    leaveIcon(imgPath, type) {
      let src_off = imgPath;
      let src = src_off.replace('_on', '_off');

      if (type === 'connection') {
        this.connectionStateImg = src;
      } else {
        this.userGuideImg = src;
      }
    },
    korVersion() {
      console.log('korVersion');
    },
    engVersion() {
      console.log('engVersion');
    },
    goPage(page) {
      if (page === 'ssoLogin') {
        this.$router.replace('/' + page);
      } else {
        this.loginTestDialog.dialog = true;
      }
      // this.$store.dispatch('setWebexLoginMode', true);
      // this.$router.push({ name: 'Login' });
    },
    closeLoginTestDialog() {
      this.loginTestDialog.dialog = false;
    },
    openCitizenParticipationDialog() {
      this.citizenParticipationDialog.dialog = true;
    },
    closeCitizenParticipationDialog() {
      this.citizenParticipationDialog.dialog = false;
    },
  },
};
</script>
<style scoped>
.hplo {
  position: fixed;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sections/Home.vue